import { BaseEntity } from "./BaseEntity";

export class MuralEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.rhdigital.mural.entity";
        this.baseEndPoint = "/rh/mural";
        this.endpoints = {
            list: this.baseEndPoint,
            create: this.baseEndPoint,
            update: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;

        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });

        return url;
    }
}
